import { useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { ArrowRight, LoaderCircle } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const WaitlistForm = ({ id = "claim", compact = false, onJoined, label = "Claim .edu Pass" }) => {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!email.trim() || loading) return;
    setLoading(true);
    try {
      const res = await axios.post(`${API}/waitlist`, { email });
      if (res.data.already) {
        toast.success("You're already on the list — sit tight, hustler.");
      } else {
        toast.success("You're in. Your .edu pass is being forged.");
      }
      setEmail("");
      onJoined?.(res.data.count);
    } catch (err) {
      toast.error(err.response?.data?.detail || "Something glitched. Try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <form
      id={id}
      data-testid="waitlist-form"
      onSubmit={submit}
      className={`flex w-full ${compact ? "max-w-md" : "max-w-xl"} flex-col gap-3 sm:flex-row`}
    >
      <input
        data-testid="waitlist-email-input"
        type="email"
        required
        value={email}
        onChange={(e) => setEmail(e.target.value)}
        placeholder="you@college.edu"
        className="h-14 flex-1 rounded-full border border-white/10 bg-white/5 px-6 font-jbmono text-sm text-slate-100 placeholder:text-slate-500 outline-none backdrop-blur-md transition-colors focus:border-[#A3E635]/60"
      />
      <button
        data-testid="waitlist-submit-button"
        type="submit"
        disabled={loading}
        className="glow-btn group flex h-14 items-center justify-center gap-2 rounded-full bg-[#A3E635] px-8 font-display text-sm font-bold uppercase tracking-wider text-[#07090E] disabled:opacity-60"
      >
        {loading ? (
          <LoaderCircle className="h-4 w-4 animate-spin" />
        ) : (
          <>
            {label}
            <ArrowRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-1" />
          </>
        )}
      </button>
    </form>
  );
};
